import { Configuration, LogLevel } from '@azure/msal-browser';

// Microsoft Entra External ID Configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID || '',
    authority: process.env.REACT_APP_MSAL_AUTHORITY || '',
    redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI || 'http://localhost:3000',
    knownAuthorities: [
      process.env.REACT_APP_MSAL_TENANT_NAME + '.ciamlogin.com'
    ],
  },
  cache: {
    // localStorage persists tokens across page refreshes, tab closes, and browser
    // reopens — dramatically reducing how often MSAL needs to interactively
    // re-authenticate. sessionStorage was causing tokens to go cold after idle,
    // which triggered the confusing Entra internal-account password prompt for
    // Google-federated users.
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};
